/* campaign-hero — rotire, numaratoare inversa, si redare video doar pe slide-ul activ.
   Slide-urile pe care promo-gate le-a stins nu ajung niciodata in DOM, deci JS-ul
   nu trebuie sa stie nimic despre campanie: numara ce gaseste. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCountdown(el) {
    var target = parseInt(el.getAttribute('data-chero-countdown'), 10) * 1000;
    if (!target || isNaN(target)) return null;

    var out = {
      d: el.querySelector('[data-cd="d"]'),
      h: el.querySelector('[data-cd="h"]'),
      m: el.querySelector('[data-cd="m"]'),
      s: el.querySelector('[data-cd="s"]')
    };

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var left = Math.floor((target - Date.now()) / 1000);
      if (left <= 0) {
        // Pagina e servita din cache minute bune; cand ceasul ajunge la zero
        // ascundem numaratoarea in loc sa aratam zerouri sau numere negative.
        el.hidden = true;
        return false;
      }
      if (out.d) out.d.textContent = Math.floor(left / 86400);
      if (out.h) out.h.textContent = pad(Math.floor(left / 3600) % 24);
      if (out.m) out.m.textContent = pad(Math.floor(left / 60) % 60);
      if (out.s) out.s.textContent = pad(left % 60);
      return true;
    }

    if (!tick()) return null;
    var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000);
    return id;
  }

  // Pot fi doua numaratori (slide-ul automat de campanie si unul manual): le pornim pe toate.
  function initCountdowns(root) {
    root.querySelectorAll('[data-chero-countdown]').forEach(function (el) { initCountdown(el); });
  }

  // Slide-ul automat de campanie poarta data-camp-until (secunde epoch): startul in faza
  // `soon`, finalul in faza `on`. Un tab ramas deschis trece de ora asta fara reload;
  // atunci slide-ul iese din carusel, ca sa nu ramana un cadru negru intre celelalte.
  function expired(el) {
    var ts = parseInt(el.getAttribute('data-camp-until'), 10);
    if (!ts) return false;
    if (typeof window.ergoCampUntilOk === 'function') return !window.ergoCampUntilOk(ts);
    return Date.now() / 1000 >= ts;
  }

  function init(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.chero__slide'));
    if (!slides.length) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('.chero__dot'));
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && slides.length > 1 && !REDUCED;
    var index = 0;
    var timer = null;

    function playMedia(slide, on) {
      var v = slide.querySelector('video');
      if (!v) return;
      if (on) {
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () { /* autoplay refuzat: ramane cadrul poster */ });
      } else {
        try { v.pause(); } catch (e) { /* noop */ }
      }
    }

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        // Un link ascuns nu trebuie sa fie oprire de Tab (nici campurile formularului de campanie).
        s.querySelectorAll('a, button, input, select, textarea').forEach(function (f) {
          if (on) f.removeAttribute('tabindex'); else f.setAttribute('tabindex', '-1');
        });
        playMedia(s, on);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    // Cat timp cineva e intr-un camp al formularului de campanie, caruselul nu pleaca de pe
    // slide (mouseleave sau revenirea in tab ar porni rotirea si ar lua focusul din camp).
    // Doar controalele dintr-un <form> au .form; sagetile si punctele nu, deci raman ca azi.
    function typing() {
      var a = document.activeElement;
      return !!(a && a.form && root.contains(a));
    }
    function start() { if (autoplay && !timer && !typing()) timer = setInterval(function () { show(index + 1); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function goto(i) { stop(); show(i); start(); }

    // Scoate slide-urile expirate (si punctul lor). Daca ramane unul singur, caruselul se
    // poarta ca azi cu un slide: fara sageti, fara puncte, fara rotire.
    function prune() {
      var cur = slides[index];
      var keepS = [];
      var keepD = [];
      slides.forEach(function (s, i) {
        if (expired(s)) {
          if (s.parentNode) s.parentNode.removeChild(s);
          if (dots[i] && dots[i].parentNode) dots[i].parentNode.removeChild(dots[i]);
        } else {
          keepS.push(s);
          if (dots[i]) keepD.push(dots[i]);
        }
      });
      if (keepS.length === slides.length) return;
      slides = keepS;
      dots = keepD;
      if (!slides.length) {
        stop();
        root.hidden = true;
        root.style.display = 'none';
        return;
      }
      if (slides.length < 2) {
        autoplay = false;
        stop();
        root.querySelectorAll('.chero__nav, .chero__dots').forEach(function (n) { n.style.display = 'none'; });
      }
      var i = slides.indexOf(cur);
      show(i < 0 ? 0 : i);
    }

    root.querySelectorAll('[data-chero-prev]').forEach(function (b) {
      b.addEventListener('click', function () { goto(index - 1); });
    });
    root.querySelectorAll('[data-chero-next]').forEach(function (b) {
      b.addEventListener('click', function () { goto(index + 1); });
    });
    // Indexul se cauta la click: dupa prune() punctele se renumeroteaza.
    dots.forEach(function (d) {
      d.addEventListener('click', function () { var i = dots.indexOf(d); if (i > -1) goto(i); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) start();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // Swipe pe mobil.
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) goto(index + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    initCountdowns(root);
    prune();
    if (!slides.length) return;
    root.setAttribute('data-ready', 'true');
    show(index);
    start();
    // Aceleasi momente ca taietura din layout/theme.liquid: altfel, la revenirea in tab,
    // slide-ul ascuns de ea ar ramane in rotatie ca un cadru gol pana la urmatorul tick.
    var campSlide = root.querySelector('.chero__slide[data-camp-until]');
    if (campSlide) {
      setInterval(prune, 30000);
      // si exact la ora (taietura din layout o ascunde atunci): fara un cadru gol pana la tick
      var due = parseInt(campSlide.getAttribute('data-camp-until'), 10) * 1000 - Date.now();
      if (due > 0 && due < 2000000000) setTimeout(prune, due + 100);
      window.addEventListener('pageshow', prune);
      document.addEventListener('visibilitychange', function () { if (!document.hidden) prune(); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-campaign-hero]').forEach(function (el) {
      if (!el.hasAttribute('data-ready')) init(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Editorul de tema re-randeaza sectiunea fara sa reincarce pagina.
  document.addEventListener('shopify:section:load', boot);
})();
